import {mainnet} from '@wagmi/core/chains';
import {createConfig, http} from '@wagmi/core';
import {injected/*, walletConnect*/} from '@wagmi/connectors';

import {WagmiAdapter} from '@reown/appkit-adapter-wagmi';
import {createAppKit} from '@reown/appkit/react';
import {zWeb3Modal} from 'r/constants/zIdxs';


const projectId = '2dd7cabe3004e6c0cf83773218b8b3ef';


export const wagmiConfig = createConfig({
  chains: [mainnet],
  projectId,
  transports: {
    [mainnet.id]: http(),
  },
  connectors: [
    injected(),
    // walletConnect({projectId, showQrModal: false}),
  ],
});


const networks = [mainnet];

export const wagmiAdapter = new WagmiAdapter({
  projectId,
  networks,
});

export const modal = createAppKit({
  adapters: [wagmiAdapter],
  networks,
  projectId,
  features: {
    email: false,
    socials: false,
  },
  themeVariables: {
    '--w3m-z-index': zWeb3Modal,
  },
  enableCoinbase: false,
});
